import * as React from 'react'
import SanityBlock from 'components/common/SanityBlock'
import HexPatternSection from 'components/common/HexPatternSection'
import Img from 'components/common/Img'

const TextIconGrid = ({ _rawContent, items }) => {
	return (
		<section className="bg-white overflow-hidden">
			<HexPatternSection>
				<header className="text-center richtext">
					<SanityBlock body={_rawContent} />
				</header>

				<ul className="max-w-screen-lg mx-auto mt-12 grid md:grid-cols-2 gap-12">
					{items?.map((item, key) => (
						<li className="grid gap-4 max-w-[450px]" key={key}>
							<figure><Img image={item.icon} /></figure>
							<h3 className="font-bold text-xl">{item.title}</h3>
							{item.description && <p>{item.description}</p>}
						</li>
					))}
				</ul>
			</HexPatternSection>
		</section>
	)
}

export default TextIconGrid
